import { Button, Icon, IconProps, Text } from '@betterleap/ui';
import { useState } from 'react';

interface ShowMoreButtonProps {
  onToggle?: (showMore: boolean) => void;
  showLessText: string;
  showMoreText: string;
  showIcon?: boolean;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  css?: any;
}

export const ShowMoreButton = ({
  onToggle,
  showLessText = 'Show less',
  showMoreText = `Show all`,
  showIcon = true,
  css,
  ...rest
}: ShowMoreButtonProps) => {
  const [isExpanded, setExpanded] = useState(false);

  const toggleParams: { text: string; icon: IconProps['name'] } = {
    text: isExpanded ? showLessText : showMoreText,
    icon: isExpanded ? 'chevron-up' : 'chevron-down',
  };

  return (
    <Button
      variant='headless'
      onClick={() => {
        setExpanded(!isExpanded);
        onToggle?.(!isExpanded);
      }}
      css={{ mt: 4, fontSize: '$sm', color: '$blue-600', ...css }}
      {...rest}
    >
      <Text inherit>{toggleParams.text}</Text>
      {showIcon && (
        <Icon
          name={toggleParams.icon}
          size={16}
          css={{ fill: '$blue-600', ml: 4 }}
        />
      )}
    </Button>
  );
};
